import api from './apiService';
import Project from '../../common/Utils/project';

export type DirectoryTenantType = 'GlobalAdmin' | 'Reseller' | 'Tenant';

/** One tenant of AuthService's user directory tree, without its users. Ids are lowercase. */
export interface DirectoryTenant {
  tenantId: string;
  tenantName: string;
  tenantType: DirectoryTenantType;
  userCount: number;
  tenants: DirectoryTenant[];
}

export const authDirectoryBase = () => `${Project.authApi}authservice/api/auth/`;

export const toDirectoryTenant = (node: any): DirectoryTenant => ({
  tenantId: String(node?.tenantId ?? '').toLowerCase(),
  tenantName: String(node?.tenantName ?? ''),
  tenantType: (['GlobalAdmin', 'Reseller', 'Tenant'].includes(node?.tenantType) ? node.tenantType : 'Tenant') as DirectoryTenantType,
  userCount: Number(node?.userCount ?? 0),
  tenants: Array.isArray(node?.tenants) ? node.tenants.map(toDirectoryTenant) : [],
});

/**
 * AuthService's tenant tree (`GET {tenantId}/user-directory?includeUsers=false`), starting from `tenantId`:
 * DefatomGlobal → every reseller with its customer tenants, plus the tenants no reseller manages;
 * a reseller → its customer tenants; any other tenant → itself. AuthService checks access to `tenantId`.
 * Rejects when the call fails or returns no tree (the shared interceptor has already toasted a failed call).
 */
export const getUserDirectoryTree = async (tenantId: string): Promise<DirectoryTenant> => {
  const response = await api.get(`${authDirectoryBase()}${encodeURIComponent(tenantId)}/user-directory?includeUsers=false`);
  const node = response?.data?.data;
  if (!node) throw new Error('No user directory');
  return toDirectoryTenant(node);
};
